<template lang="html">
  <div class="credits">
    <h3 v-text="$ml.get('credits.title')"/>
    <b-card-group deck>
      <b-card
        class="client-card mb-4"
        v-for="(c, index) in clienti"
        :key="index"
        :img-src="'static/img/clients/' + c.logo">
        <b-button :href="c.url" target="_blank" class="red-button">{{ c.text }}</b-button>
      </b-card>
    </b-card-group>
    <b-button v-show="showGoTop" id="goTopBtn" @click="goTop()">Top</b-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      clienti: [
        { logo: 'cablog_logo.jpg', text: 'Cablog Srl', url: 'https://www.cab-log.it/' },
        { logo: 'ellebi_logo.jpg', text: 'Ellebi & A. Autotrasporti', url: 'https://www.ellebiautotrasporti.it/' },
        { logo: 'scl_logo.jpg', text: 'Silvano Chiapparoli Logistica Spa', url: 'http://www.chiapparolionline.it' },
        { logo: 'pt-visirun.png', text: 'Visirun Spa', url: 'https://www.visirun.com/it/lecosistema-visirun-per-il-controllo-satellitare-integrato/' },
        { logo: 'zanardo_logo.jpg', text: 'Zanardo Servizi Logistici Spa', url: 'http://www.zanardo.it/' },
        { logo: 'logtrasportisrl.jpg', text: 'Logistica e Trasporti Srl', url: 'http://www.logisticaetrasporti.it' },
        { logo: 'logos_srl.png', text: 'LOG-OS S.r.l.', url: 'http://www.zanardo.it/page.php?id=1175' },
        { logo: 'Logo_edp.png', text: 'EDP Delivery Service Srl', url: 'http://www.edpdelivery.com/' }
      ],
      old: [
        { logo: 'world_logistics.jpg', text: 'World Logistics Srl', url: 'https://www.worldlogistics.it/' },
        { logo: 'matras.jpg', text: 'Matras Srl', url: 'https://www.matrasts.it/' }
      ],
      showGoTop: false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400
    },
    goTop () {
      window.scroll({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style lang="css" scoped>

.client-card {
  min-width: 30%;
  max-width: 30%;
}

.client-card {
  -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
}

.card-deck {
  margin: 25px;
}

@media only screen and (max-width: 600px) {
  .client-card {
    min-width: 100%;
    max-width: 100%;
  }
}

.red-button {
  background-color: #E0161A;
  color: #FDFDFD;
  border: none;
  outline: none;
  padding: .4rem 1.3rem;
}

.red-button:hover {
  background-color: #444;
}
</style>



// WEBPACK FOOTER //
// src/components/Credits.vue